import { render, staticRenderFns } from "./shipping-group-total-item.vue?vue&type=template&id=1ff451f8&"
import script from "./shipping-group-total-item.vue?vue&type=script&lang=js&"
export * from "./shipping-group-total-item.vue?vue&type=script&lang=js&"
import style0 from "./shipping-group-total-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff451f8')) {
      api.createRecord('1ff451f8', component.options)
    } else {
      api.reload('1ff451f8', component.options)
    }
    module.hot.accept("./shipping-group-total-item.vue?vue&type=template&id=1ff451f8&", function () {
      api.rerender('1ff451f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-total-widget/shipping-group-total-item.vue"
export default component.exports